import React, { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Dialog, DialogActions, Box, DialogContent, DialogTitle, MenuItem, FormControl, Select, TextField, Typography, InputAdornment, IconButton, Step, Stepper, StepContent, StepLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Button, Paper } from '@mui/material';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { searchTypes } from '../../../Config/constants';
import { dataService } from '../../../Services/data/data.service';

import { useTranslation } from 'react-i18next';
import { X, LoaderCircle } from 'lucide-react';



export default function ActiveSSCCDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    const [submitting, setSubmitting] = useState(false);

    const [printsQuantity, setPrintsQuantity] = useState(1);
    const [selectedPrinter, setSelectedPrinter] = useState(props.printers[0].Id);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [reason, setReason] = useState('');
    const [printError, setPrintError] = useState(null);

    useEffect(() => {
        // set printer to first from printer list
        if (props.printers !== null && props.printers !== undefined && props.printers.length > 0) {
            props.setPrinterSelected(props.printers[0].Id);
        }
    }, [props.printers]);

    const formatDate = (date) => {
        var d = new Date(date);

        // Get the day, month, and year
        let day = d.getDate();
        let month = d.getMonth() + 1;
        let year = d.getFullYear();

        // Pad the day and month with leading zeros if necessary
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;

        // Return the formatted date string
        return day + "/" + month + "/" + year;
    };

    const handleGoBack = () => {
        setSelectedOrder(null);
        setPrintError(null);
    };

    /******* START STEP 2: HANDLE NEW SSCC **********/
    const handleNewLabel = () => {
        if (props.submitting) {
            return;
        } else {
            props.setSubmitting(true);
            var tempUserId = props.userId !== null && props.userId !== undefined ? props.userId : -1;
            dataService.getNewPalletNumber(selectedOrder.Reference, props.workstationId, tempUserId, printsQuantity, selectedReason.Id, reason).then(result => {
                if (result !== '' && result !== null && result !== undefined && result.ok) {
                    if (result.data.Succeeded) {
                        //Carrier gevonden, doe het nodige...
                        props.setNewSSCC(JSON.parse(result.data.Results).CarrierBarcode);
                        props.setProductId(selectedOrder.ProductId);
                        props.setOrderId(selectedOrder.OrderId);
                        props.openAuthenticateDialog();
                    } else {
                        setPrintError(t('Geen pallet gevonden voor order met referentie') + ' ' + selectedOrder.Reference);
                        props.setSubmitting(false);
                    }
                } else {
                    //Problemen
                    props.setSubmitting(false);
                }
            }).catch((error) => {
                console.log('error ', error)
                props.setSubmitting(false);
            });
        }
    };

    const handleSelectOrder = (order) => {
        setSelectedOrder(order);
    };

    /******* END STEP 2: HANDLE NEW SSCC **********/

    /******* START STEP 4: HANDLE PRINTING **********/
    const handlePrinterSelection = (e) => {
        setSelectedPrinter(e.target.value);
        props.setPrinterSelected(e.target.value);
    };

    const handleReasonSelection = (e) => {
        setSelectedReason(e.target.value);
        props.setPrintReasonId(e.target.value);
    };

    const handleSetPrintReasonDescription = (value) => {
        setReason(value);
        props.setPrintReasonDescription(value);
    };

    const handlePrintsQuantity = (quantity) => {
        setPrintsQuantity(quantity);
        props.setPrintsQuantity(quantity);
    }

    const printLabel = () => {
        handleNewLabel();
    };
    /******* END STEP 4: HANDLE PRINTING **********/

    return (

        <Dialog className={classes.dialog}
            open={props.dialogOpen}
            onClose={props.closeDialog}

            classes={{ paper: classes.dialogPaper }}

            aria-labelledby="draggable-dialog-title"
        >
            <div className={classes.dialog__head}>
                <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                    {selectedOrder === null ?
                        t("Open orders") + " (" + props.productCode + ")"
                        :
                        t("Print label")}
                </DialogTitle>
                <button onClick={() => props.closeDialog()} className={classes.dialog__closeButton}>
                    <X size={19} />
                </button>
            </div>
            <DialogContent className={classes.dialog__contentContainer}>
                {/* selectionList */}
                <div className={classes.dialog__orderSelectionContainer}>
                    {(selectedOrder === null || (selectedOrder !== null && selectedOrder.PalletFound)) &&
                        <table className={classes.dialog__table}>
                            <thead className={classes.dialog__tableHead}>
                                <tr className={classes.dialog__tableRow} style={{ position: 'relative' }}>
                                    <th className={classes.dialog__tableHead__indicator}></th>
                                    <th className={classes.dialog__tableHeader} style={{ borderRadius: '3px 0px 0px 3px' }}>{t('#')}</th>
                                    <th className={classes.dialog__tableHeader}>{t('Description')}</th>
                                    <th className={classes.dialog__tableHeader} style={{ textAlign: 'right' }}>{t('Quantity')}</th>
                                    <th className={classes.dialog__tableHeader}>UOM</th>
                                    <th className={classes.dialog__tableHeader} style={{ textAlign: 'center' }}>{t('Machine')}</th>
                                    <th className={classes.dialog__tableHeader}>{t('Start date')}</th>
                                </tr>
                            </thead>
                            {selectedOrder === null ?
                                // Active orders
                                <tbody className={classes.dialog__tableBody}>
                                    {props.activeProductionOrders.some(x => x) ?
                                        props.activeProductionOrders.map((row) => (
                                            <tr key={'activeProductionOrders_' + row.Reference} className={classes.dialog__selectionTableRow} onClick={() => handleSelectOrder(row)}>
                                                <td className={classes.dialog__selectionTableRow__indicator}></td>
                                                <td className={classes.dialog__tableData} style={{ borderRadius: '3px 0px 0px 3px' }}>{row.Reference}</td>
                                                <td className={classes.dialog__tableData} style={{ overflow: 'hidden', textWrap: 'nowrap', textOverflow: 'ellipsis', maxWidth: '220px' }}>{row.NameFR}</td>
                                                <td className={classes.dialog__tableData} style={{ textAlign: 'right' }}>{row.Quantity}</td>
                                                <td className={classes.dialog__tableData}>{row.QuantityFactor}</td>
                                                <td className={classes.dialog__tableData} style={{ textAlign: 'center' }}>{row.MachineCode || "-"}</td>
                                                <td className={classes.dialog__tableData}>{formatDate(row.StartedOn)}</td>
                                            </tr>
                                        ))
                                        :
                                        <tr><td colSpan={5}>{t('Geen orders met actieve palletten teruggevonden.')}</td></tr>
                                    }

                                </tbody>
                                :
                                // Selected order
                                <tbody className={classes.dialog__tableBody}>
                                    <tr key={'selectedOrder' + selectedOrder.Reference} className={classes.dialog__selectedOrderRow}>
                                        <td className={classes.dialog__selectionTableRow__indicator}></td>
                                        <td className={classes.dialog__tableData} style={{ borderRadius: '3px 0px 0px 3px' }}>{selectedOrder.Reference}</td>
                                        <td className={classes.dialog__tableData} style={{ overflow: 'hidden', textWrap: 'nowrap', textOverflow: 'ellipsis', maxWidth: '220px' }}>{selectedOrder.NameFR}</td>
                                        <td className={classes.dialog__tableData} style={{ textAlign: 'right' }}>{selectedOrder.Quantity}</td>
                                        <td className={classes.dialog__tableData}>{selectedOrder.QuantityFactor}</td>
                                        <td className={classes.dialog__tableData} style={{ textAlign: 'center' }}>{selectedOrder.MachineCode || "-"}</td>
                                        <td className={classes.dialog__tableData}>{formatDate(selectedOrder.StartedOn)}</td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    }
                </div>
                {selectedOrder !== null &&
                    <>
                        {printError ?
                            <div className={classes.dialog__printErrorContainer}>
                                <p className={classes.dialog__printError}>{printError}</p>
                            </div>
                            :
                            <div className={classes.dialog__printContainer}>
                                <div className={classes.dialog__printSettingsContainer}>
                                    <div className={classes.dialog__printSetting} style={{ width: '30%' }}>
                                        <label className={classes.dialog__printSettingsLabel}>{t("Reason")}*</label>
                                        <Select
                                            className={classes.dialog__printSettingsField}
                                            labelId="demo-simple-select-label"
                                            placeholder="test"
                                            id="demo-simple-select"
                                            value={selectedReason}
                                            onChange={handleReasonSelection}
                                            sx={{ width: '100%' }}
                                        >
                                            {props.printReasons.map((reason, index) => {
                                                return <MenuItem value={reason.Id} key={"reason_" + index}>{t(reason.ReasonName)}</MenuItem>
                                            })}
                                        </Select>
                                    </div>
                                    <div className={classes.dialog__printSetting} style={{ width: '70%' }}>
                                        <label className={classes.dialog__printSettingsLabel}>{t("Extra information about reason")}</label>
                                        <TextField
                                            className={classes.dialog__printSettingsField}
                                            id="reason"
                                            type="text"
                                            value={reason}
                                            onChange={(e) => handleSetPrintReasonDescription(e.target.value)}
                                            sx={{ width: '100%' }}
                                            InputProps={{
                                                style: {
                                                    height: '40px',
                                                    fontFamily: "Lato, sans-serif",
                                                    fontSize: '16px',
                                                    color: '#0C0E29',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={classes.dialog__printSettingsContainer}>
                                    <div className={classes.dialog__printSetting}>
                                        <label className={classes.dialog__printSettingsLabel}>{t("Select a printer")}</label>
                                        <Select
                                            className={classes.dialog__printSettingsField}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedPrinter}
                                            disabled
                                            onChange={handlePrinterSelection}
                                            sx={{ width: '100%' }}
                                        >
                                            {props.printers.map((printer, index) => {
                                                return <MenuItem value={printer.Id} key={"printer_" + index}><b style={{ paddingRight: '5px' }}>{printer.Code}:</b> {printer.Name}</MenuItem>
                                            })}
                                        </Select>
                                    </div>
                                    <div className={classes.dialog__printSetting}>
                                        <label className={classes.dialog__printSettingsLabel}>{t("Number of prints")}</label>
                                        <TextField
                                            className={classes.dialog__printSettingsField}
                                            id="boxes"
                                            type="number"
                                            value={printsQuantity}
                                            onChange={(e) => handlePrintsQuantity(e.target.value)}
                                            sx={{ width: '100%' }}
                                            InputProps={{
                                                style: {
                                                    height: '40px',
                                                    fontFamily: "Lato, sans-serif",
                                                    fontSize: '16px',
                                                    color: '#0C0E29',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }

            </DialogContent>
            <DialogActions className={classes.dialog__buttonContainer}>
                {selectedOrder !== null &&
                    <>
                        <Button className={classes.dialog__button__secondary} onClick={() => handleGoBack()}>
                            {t('Back')}
                        </Button>
                        <button className={`${classes.dialog__button} ${props.submitting ? classes.dialog__button_loading : ""}`} disabled={props.printerSelected === null || printsQuantity < 1 || selectedReason === null || printError} onClick={() => printLabel()}>
                            {props.submitting && <div className={classes.button__loader}><LoaderCircle className={classes.button__loader__spinner} /></div>}
                            {props.buttonText ? props.buttonText : t('Print')}
                        </button>
                    </>
                }
            </DialogActions>
        </Dialog >
    );
}

const useStyles = makeStyles(() => ({

    dialog: {
        // width: "720px !important",
        // height: "384px !important",
        margin: "auto"
    },

    dialogPaper: {
        minWidth: '720px',
        minHeight: '384px',
        maxWidth: 'calc(100vw - 512px) !important',
        width: '800px !important',
        height: '480px !important',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'backgroundColor 0.2s, color 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus': {
            outline: '#4654FB auto 1px',
        },

    },

    dialog__contentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: '0px 16px !important',
        marginBottom: '16px !important',

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',

    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },

    dialog__productSelectionContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '16px',
    },

    dialog__table: {
        width: '100%',
        borderCollapse: 'collapse',

        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        color: '#0C0E29',
        marginBottom: '8px'
    },

    dialog__tableHead: {
        width: '100%',
        backgroundColor: '#EDEDED',
        border: 'none',
        borderRadius: '3px',

        position: "sticky",
        top: "0",
        zIndex: "999",
    },

    dialog__tableHead__inactiveOrders: {
        width: '100%',
        backgroundColor: '#fbe5e5',
        border: 'none',
        borderRadius: '3px',

        position: "sticky",
        top: "0",
        zIndex: "999",
    },

    dialog__tableRow: {
        maxWidth: '100%',
    },

    dialog__selectionTableRow_inactiveOrder: {
        maxWidth: '100%',
        cursor: 'default',

        transition: 'backgroundColor 0.3s',

        position: 'relative',

        '&:hover': {
            backgroundColor: '#F5F5F5',
        },
    },

    dialog__selectionTableRow: {
        maxWidth: '100%',
        cursor: 'pointer',

        transition: 'backgroundColor 0.3s',

        position: 'relative',

        '&:hover': {
            backgroundColor: '#F5F5F5',

            '& $dialog__selectionTableRow__indicator': {
                backgroundColor: FlagstoneTheme.palette.primary.main,
            },
        },
    },

    dialog__selectedOrderRow: {
        maxWidth: '100%',
        position: 'relative',
    },

    dialog__tableHead__indicator: {
        position: 'absolute',
        top: '0px',
        left: '0px',
    },

    dialog__selectionTableRow__indicator: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '3px',
        height: '100%',
        backgroundColor: 'transparent',
        borderRadius: '3px 0px 0px 3px',

        transition: 'backgroundColor 0.3s',
    },


    dialog__tableHeader: {
        textAlign: 'left',
        padding: '8px 12px !important',

        fontWeight: 'normal',

        // first child and second  child border radiuis
        '&:first-child': {
            borderRadius: '3px 0px 0px 3px',
            paddingLeft: '14px'
        },
        '&:last-child': {
            borderRadius: '0px 3px 3px 0px'
        },
    },

    dialog__tableBody: {
        width: '100%',

        '&:before': {
            content: '""',
            display: 'block',
            height: '8px',
            backgroundColor: 'transparent',
        },
    },

    dialog__tableData: {
        textAlign: 'left',
        padding: '8px 12px !important',

        fontWeight: 'normal',

        // first child and second  child border radiuis
        '&:first-child': {
            borderRadius: '3px 0px 0px 3px',
            paddingLeft: '14px'
        },
        '&:last-child': {
            borderRadius: '0px 3px 3px 0px'
        },
    },

    dialog__printErrorContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px',
        borderRadius: '6px',
        border: "1px solid #D84949",
        backgroundColor: '#fbe5e5',
        boxSizing: 'border-box',
        marginTop: '24px',
    },

    dialog__printError: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: '#D84949',
    },

    dialog__printContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '24px',
    },

    dialog__printSettingsContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
    },

    dialog__printSetting: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },

    dialog__printSettingsLabel: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: '#0C0E29',
    },

    dialog__printSettingsField: {
        width: '100%',
        height: '40px !important',
        padding: '0px !important',
    },

    dialog__buttonContainer: {
        width: '100%',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between !important',

        padding: '16px !important',
        paddingTop: '0px !important',
        margin: '0px !important',
    },

    dialog__button: {
        color: "white !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        border: "none !important",
        borderRadius: "3px !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'none !important',
        position: 'relative !important',

        transition: 'all 0.2s !important',

        '&:hover': {
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
            cursor: "pointer !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    dialog__button_loading: {
        backgroundColor: "#C3D3FF !important",
        color: "#C3D3FF !important",

        '&:hover': {
            backgroundColor: "#C3D3FF !important",
            color: "#C3D3FF !important",
            cursor: "default !important",
        },
    },

    button__loader: {
        width: "24px",
        height: "24px",
        color: FlagstoneTheme.palette.primary.main,

        position: "absolute",
        display: "block",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },

    button__loader__spinner: {
        width: "100%",
        height: "100%",

        animation: "spin 1s linear infinite",
    },

    '@global': {
        '@keyframes spin': {
            '0%': {
                transform: 'rotate(0deg)',
            },
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
    },

    dialog__button__secondary: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "white !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',

        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },


    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    }, stepButton: {
        zIndex: 1,
        color: "#fff",
        width: 50,
        height: 50,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
    },
    buttons: {
        textAlign: "center"
    },
    okButton: {
        color: "white !important",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold !important",
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: 'fit-content',
        textTransform: 'none !important',

        '&:hover': {
            backgroundColor: "white !important",
            color: FlagstoneTheme.palette.primary.main + " !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    searchButton: {
        color: "white !important",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold !important",
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "144px",

        '&:hover': {
            backgroundColor: "white !important",
            color: FlagstoneTheme.palette.primary.main + " !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },


    closeButton: {
        color: FlagstoneTheme.palette.primary.main + ' !important',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold !important',
        backgroundColor: "white !important",
        marginRight: '15px !important',
        border: "1px solid " + FlagstoneTheme.palette.primary.main + ' !important',
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + ' !important',
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + ' !important',
        },
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
    },
    dialogContext: {
        color: "#000000",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    }
}));
